import React from 'react';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import './DescriptionBox.less';
type Props = {
	description?: string;
	showDefault: boolean;
};

const renderDescription = (description?: string) => {
	if (!description || !description.length) {
		return (
			<Trans i18nKey="updatejobs.description.defaultMessage">
				We have scheduled a firmware update for your devices to improve stability and performance.
			</Trans>
		);
	}

	return description.split('\n').map((chunk, index) => (
		<p key={index}>
			{chunk}
			&nbsp;
		</p>
	));
};

const DescriptionBox = ({description, showDefault}: Props) => {
	if (!description && !showDefault) {
		return null;
	}

	return (
		<div className="job-update-description-box" data-testid="job-update-description-box">
			{renderDescription(description)}
		</div>
	);
};

export default DescriptionBox;
